import React, { useEffect, useState } from 'react';
import SweetAlert from 'hooks/SweetAlert';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

// core components
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardAvatar from 'components/Card/CardAvatar.js';
import CardFooter from 'components/Card/CardFooter.js';

import { TextField } from '@material-ui/core';

import styles from 'assets/jss/material-dashboard-pro-react/views/lockScreenPageStyle.js';
import { WithApp } from 'contexts/appContext';
import { wsUpdate } from 'services/WService';

const useStyles = makeStyles(styles);

export default WithApp(function LockScreenPage(props) {
  const classes = useStyles();
  const [cardAnimaton, setCardAnimation] = useState('cardHidden');
  const [alert, setAlert] = useState({ alert: '', message: '' });
  const [stateConfirm, setStateConfirm] = useState(null);

  const [data, setData] = useState({});

  const [registerPassword, setregisterPassword] = useState('');
  const [registerPasswordState, setregisterPasswordState] = useState('');
  const [registerConfirmPasswordState, setregisterConfirmPasswordState] = useState('');
  const [registerConfirmPassword, setregisterConfirmPassword] = useState('');

  // function that verifies if a string has a given length or not
  const verifyLength = (value, length) => {
    if (value.length >= length) {
      return true;
    }
    return false;
  };

  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value
    });
  };

  async function changePassword(data) {
    /* console.log(data); */
    setAlert({ alert: 'loading', open: true });
    if (data.newPassword == data.confirmPassword) {
      let response = await wsUpdate('oauth/user/current', null, data);
      if (response.success) {
        setAlert({
          alert: response.success ? 'success' : 'error',
          message: response.message
        });
      }
    } else {
      setAlert({
        alert: 'warning',
        message: 'La nueva contraseña no coincide con la confirmación.'
      });
    }
  }

  useEffect(() => {
    let id = setTimeout(function () {
      setCardAnimation('');
    }, 700);
    // Specify how to clean up after this effect:
    return function cleanup() {
      window.clearTimeout(id);
    };
  });

  useEffect(() => {
    /* console.log(data); */
  }, [data]);

  return (
    <div
      className={classes.container}
      style={{ backgroundImage: '/static/media/login.59fc83e2.jpeg' }}
    >
      <SweetAlert alert={alert} stateConfirm={setStateConfirm} />
      <form
        onSubmit={(e) => {
          e.preventDefault();
          changePassword(data);
        }}
      >
        <Card
          profile
          className={classes.customCardClass + ' ' + classes[cardAnimaton]}
          style={{ width: '400px' }}
        >
          <br />
          <br />
          <CardAvatar profile className={classes.cardAvatar} style={{ marginTop: '-80px' }}>
            <a href="#" onClick={(e) => e.preventDefault()}>
              <img
                src={'https://gravatar.com/avatar/fa110e100fd09cd4ebb854f9ac8981c5?s=&d=mp'}
                alt="..."
              />
            </a>
          </CardAvatar>
          <CardBody profile>
            <h4 className={classes.cardTitle}>{localStorage.getItem('emailUser')}</h4>
            <TextField
              label="Contraseña actual"
              name="password"
              inputProps={{ required: true, onChange: handleChange }}
              type="password"
              fullWidth
              margin="normal"
              size="small"
            />
            <TextField
              error={registerPasswordState === 'error'}
              label="Nueva contraseña"
              onChange={handleChange}
              inputProps={{
                required: true,
                name: 'newPassword',
                onChange: (event) => {
                  if (verifyLength(event.target.value, 1)) {
                    setregisterPasswordState('success');
                  } else {
                    setregisterPasswordState('error');
                  }
                  setregisterPassword(event.target.value);
                },
                type: 'password',
                autoComplete: 'off'
              }}
              fullWidth
              margin="normal"
              size="small"
            />
            <TextField
              error={registerConfirmPasswordState === 'error'}
              label="Confirmar contraseña"
              onChange={handleChange}
              inputProps={{
                required: true,
                name: 'confirmPassword',
                onChange: (event) => {
                  if (registerPassword === event.target.value) {
                    setregisterConfirmPasswordState('success');
                  } else {
                    setregisterConfirmPasswordState('error');
                  }
                  setregisterConfirmPassword(event.target.value);
                },
                type: 'password',
                autoComplete: 'off'
              }}
              fullWidth
              margin="normal"
              size="small"
            />
            {/* <CustomInput
              labelText="Contraseña actual"
              id="company-disabled"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                required: true,
                type: "password",
                autoComplete: "off",
                name: "password",
                onChange: handleChange
              }}
              size="small"
            />
            <CustomInput
              required={true}
              success={registerPasswordState === "success"}
              error={registerPasswordState === "error"}
              labelText="Nueva Contraseña"
              id="registerpassword"
              formControlProps={{
                fullWidth: true
              }}
              onChange={handleChange}
              inputProps={{
                required: true,
                name: "newPassword",
                onChange: (event) => {
                  if (verifyLength(event.target.value, 1)) {
                    setregisterPasswordState("success");
                  } else {
                    setregisterPasswordState("error");
                  }
                  setregisterPassword(event.target.value);
                },
                type: "password",
                autoComplete: "off"
              }}
              size="small"
            />
            <CustomInput
              required={true}
              success={registerConfirmPasswordState === "success"}
              error={registerConfirmPasswordState === "error"}
              labelText="Confirmar Contraseña"
              id="registerconfirmpassword"
              formControlProps={{
                fullWidth: true
              }}
              onChange={() => handleChange}
              inputProps={{
                required: true,
                name: "confirmPassword",
                onChange: (event) => {
                  if (registerPassword === event.target.value) {
                    setregisterConfirmPasswordState("success");
                  } else {
                    setregisterConfirmPasswordState("error");
                  }
                  setregisterConfirmPassword(event.target.value);
                },
                type: "password",
                autoComplete: "off"
              }}
              size="small"
            /> */}
          </CardBody>
          <CardFooter className={classes.justifyContentCenter}>
            <Button color={props.themeContext.buttonColor} round type="submit">
              Actualizar Contraseña
            </Button>
          </CardFooter>
        </Card>
      </form>
    </div>
  );
});
